import { render, staticRenderFns } from "./DsBreezeLogo.vue?vue&type=template&id=1af2f4de&"
import script from "./DsBreezeLogo.vue?vue&type=script&lang=js&"
export * from "./DsBreezeLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports